import { render, staticRenderFns } from "./NeedForm.vue?vue&type=template&id=a7841f2c&"
import script from "./NeedForm.vue?vue&type=script&lang=js&"
export * from "./NeedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedForm.vue"
export default component.exports